import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ShowDots extends BaseOption {
  static userInterfaceComponent = {
    label: "Show Dots",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    props: {
      options: [
        {
          label: "Yes",
          value: true,
          tooltip: "",
        },
        {
          label: "No",
          value: false,
          tooltip: "",
        },
      ],
    },
  };

  static defaultValue = false;
}
